
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/awin",
      function () {
        return require("private-next-pages/destinations/awin.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/awin"])
      });
    }
  